<template>
  <div class="tabs-component">
    <ul role="tablist" class="tabs-component-tabs tabs-component-ul">
      <li
        v-for="(tab, i) in tabs"
        :key="i"
        :class="{ 'is-active': tab.isActive, 'is-disabled': tab.isDisabled }"
        class="tabs-component-tab"
        role="presentation"
        v-show="tab.isVisible">
        <a
          v-html="tab.header"
          :aria-controls="tab.hash"
          :aria-selected="tab.isActive"
          @click="selectTab(tab.hash, $event)"
          class="tabs-component-tab-a"
          role="tab">
        </a>
      </li>
    </ul>
    <div class="tabs-component-panels">
      <slot/>
    </div>
  </div>
</template>


<script>
  export default {
    props: {
      options: {
        type: Object,
        required: false,
        default () {
          return {
            useUrlFragment: true
          }
        }
      }
    },
    data () {
      return {
        tabs: [],
        activeTabHash: ''
      }
    },
    created () {
      this.tabs = this.$children
    },
    mounted () {
      window.addEventListener('hashchange', () => this.selectTab(this.$route.hash))
      if (this.findTab(this.$route.hash)) {
        this.selectTab(this.$route.hash)
        return
      }
      if (this.tabs.length) {
        this.selectTab(this.tabs[0].hash)
      }
    },
    methods: {
      findTab (hash) {
        return this.tabs.find(tab => tab.hash === hash)
      },
      selectTab (selectedTabHash, event) {
        if (event && !this.options.useUrlFragment) {
          event.preventDefault()
        }
        const selectedTab = this.findTab(selectedTabHash)
        if (!selectedTab) {
          return
        }
        if (selectedTab.isDisabled) {
          return
        }
        this.tabs.forEach(tab => {
          tab.isActive = (tab.hash === selectedTab.hash)
        })
        this.$emit('changed', {
          tab: selectedTab.header
        })
        if (window.history.state) {
          window.history.replaceState(window.history.state, '', selectedTab.hash)
        } else {
          window.history.replaceState({}, '', selectedTab.hash)
        }
        this.activeTabHash = selectedTab.hash
      },
      setTabVisible (hash, visible) {
        const tab = this.findTab(hash)
        if (!tab) {
          return
        }
        tab.isVisible = visible
        if (tab.isActive) {
          tab.isActive = visible
          this.tabs.every((tab, index, array) => {
            if (tab.isVisible) {
              tab.isActive = true
              return false
            }
            return true
          })
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/ui/NavTab.vue